<script setup lang="ts">
import IconsMagic from '~/pages/magic/@components/Icons/Magic/index.vue'

const { colors } = useTheme()
</script>

<template>
  <section flex="~ col" justify-center items-center mb-50px mt-50px p-12px>
    <div flex items-center justify-center mb-12px>
      <IconFilledStar />

      <Heading style="font-family: Circular Std Bold, sans-serif" level="4" :color="colors.darkPurple" mr-2 ml-2>
        INTRODUCING MAGIC
      </Heading>

      <IconFilledStar />
    </div>

    <Heading w="630px <md:full" style="font-family: Circular Std Book, sans-serif; lineHeight: 32px" level="2-light" :color="colors.black" text-center>
      The spellbinding plugin that enhances your AI skills. Magic simplifies prompt management,
      integrates hotkeys to ChatGPT and offers thousands of prompts made by Snack Prompt community.
    </Heading>

    <NuxtLink
      :to="LINKS.extension.magicChromeWebStore"
      target="_blank"
      flex items-center justify-center bg-black w-full max-w-322px rounded-6 mt-36px color-white font-500 pt-8px pb-8px hover-bg-purple
    >
      <IconsMagic size="26" background-color="transparent" />

      <Heading style="font-family: Circular Std Book, sans-serif" level="4" :color="colors.white" ml-5px>
        Install Magic
      </Heading>
    </NuxtLink>

    <div flex flex-wrap justify-center mt-60px>
      <div flex flex-col mr="30px <sm:10px" ml="30px <sm:0">
        <div flex>
          <img
            src="~/assets/images/Magic/iconsGroup.png"
            alt="Propts Creators"
            h-20px
          >

          <Heading style="font-family: Circular Std Book, sans-serif" level="2" :color="colors.softBlack">
            220K+
          </Heading>
        </div>

        <Text style="font-family: Circular Std Book, sans-serif" variant="small" :color="colors.darkerGray">
          Prompt Creators
        </Text>
      </div>

      <div flex flex-col mb-15px mr="20px <sm:10px" ml-20px>
        <Heading style="font-family: Circular Std Book, sans-serif" level="2" :color="colors.softBlack">
          22 million+
        </Heading>

        <Text style="font-family: Circular Std Book, sans-serif" variant="small" :color="colors.darkerGray">
          Prompts Opened (All time)
        </Text>
      </div>

      <div flex flex-col items-center justify-center mr-30px ml-30px>
        <div flex flex-col>
          <div flex items-center>
            <IconArrow :size="24" background-color="transparent" :stroke-color="colors.green2" />

            <Heading style="font-family: Circular Std Book, sans-serif" level="2" :color="colors.softBlack">
              40%
            </Heading>
          </div>

          <Text ml-5px style="font-family: Circular Std Book, sans-serif" variant="small" :color="colors.darkerGray">
            Productivity Boost
          </Text>

          <a
            flex justify-end w-full
            href="https://newsroom.accenture.com/news/accenture-report-artificial-intelligence-has-potential-to-increase-corporate-profitability-in-16-industries-by-an-average-of-38-percent-by-2035.htm"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text style="font-family: Circular Std Book, sans-serif" text-5px variant="caption" :color="colors.darkGray">
              Accenture
            </Text>

            <IconArrow :size="14" background-color="transparent" :stroke-color="colors.darkGray" style="transform: rotate(45deg)" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
